module.exports = __webpack_public_path__ + "static/media/btn-download@2x.e11fa42b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/btn-download@2x.png
// module id = 899
// module chunks = 0